import React, {Component} from "react";
import {Button} from "reactstrap";
import {dateHelper} from "../../Applications/shared/shared";
import Dropzone from "react-dropzone";
import {deleteData, patchData, uploadFile} from "../../../api/doLogin";
import {hasPermission, RequiredPermission} from "../../../api/permissionHelper";
import {toast} from "react-toastify";
import {EventClient} from "../../../util/eventClient";

export default class DocumentsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filesLoading: false,
    }
    this.acceptedMimes = ["image/jpeg", "image/png", "image/gif", "application/pdf"];
  }

  setAddMode(on) {
    this.setState({showAdd: on, note: ""}, () => this.props.onAddMode && this.props.onAddMode(on));
  }


  dropError(context, error) {
    //alert('Error');
  }

  onDrop(acceptedFiles, rejectedFiles) {
    if (!hasPermission(RequiredPermission.LMSSave)) return;
    // console.log(acceptedFiles, rejectedFiles)
    var self = this;
    this.setState({
      // dropzoneActive: false,
      filesLoading: true
    });
    //console.log(acceptedFiles);
    //console.log(rejectedFiles);
    let req = new FormData;
    acceptedFiles.forEach(file => {
      req.append('file', file);
    });
    req.append('action', 'UploadFile');
    // req.append('folderId', "0");
    uploadFile(`lms/${this.props.lmsId}/file/add`, req)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          toast.success('File(s) Uploaded Successfully');
          // self.updateData();
          self.setState({
            filesLoading: false
          }, () => {
            let newDocs = [...this.props.documents || []].concat(data.data.data);
            newDocs.sort((docA, docB) => docB.id - docA.id);
            this.props.onUpdate && this.props.onUpdate(newDocs);
          });
        } else {
          toast.error("Error " + data.message);
          self.setState({
            filesLoading: false
          });
        }
      })
      .catch(error => {
        self.setState({
          filesLoading: false
        });
        console.error(error);
      });
  }

  onDragEnter() {
    // this.setState({
    //   dropzoneActive: true
    // });
  }

  onDragLeave() {
    // this.setState({
    //   dropzoneActive: false
    // });
  }

  setVisibility(document, visibility) {
    const self = this;
    patchData(`lms/${document.lid || 0}/file/${document.id || 0}/visibility/${visibility}`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          document.access = visibility;
          self.onUpdate(document)
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  deleteFile(document) {
    const self = this;
    // self.onUpdate(document, true);
    // return;
    deleteData(`lms/${document.lid || 0}/file/${document.id || 0}`, {})
      .then((data) => {
        // console.log(data);
        if (data.status === "Success") {
          self.onUpdate(document, true);
        }
      })
      .catch(error => {
        console.error(error);
      });
  }

  onUpdate(document, remove = false) {
    const documents = this.props.documents.filter((doc) => {
      return !remove ? true : doc.id !== document.id;
    }).map((doc) => {
      if (doc.id === document.id) {
        return document;
      } else {
        return doc;
      }
    });
    this.props.onUpdate && this.props.onUpdate([...documents]);
  }

  render() {
    return <Dropzone style={{width: '100%', border: '0px dashed'}}
                     accept={this.acceptedMimes.join(", ")}
                     disableClick
                     onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)} maxSize={52428800}
                     onDragEnter={() => this.onDragEnter()} onDragLeave={() => this.onDragLeave()}>
      {({getRootProps, getInputProps, open}) => (
        <div {...getRootProps()}>
          <input {...getInputProps()} />
          {hasPermission(RequiredPermission.LMSSave) && (
            <div><Button className={"primary"}
                         onClick={() => open()}>Upload</Button></div>
          )}
          <div style={{overflowY: "auto", maxHeight: 600, overflowWrap: "anywhere"}}>
            <table cellSpacing={5} cellPadding={5}>
              <thead>
              <tr>
                <td style={{width: "60%"}}>Filename</td>
                <td style={{width: "20%"}}>Date / User</td>
                <td style={{width: "10%"}}>Visibility</td>
                <td style={{width: "10%"}}>Action</td>
              </tr>
              </thead>
              <tbody>
              {this.props.documents && this.props.documents.map((document, index) => {

                return <tr key={index} style={{paddingBottom: 10, borderBottom: "1px solid black"}}>
                  <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>
                    <a href={document.url} target={"_blank"}>{document.filename}</a>
                  </td>
                  <td style={{verticalAlign: "top"}}>
                    {dateHelper(new Date(document.dated))}
                    <br/>
                    {!document.FName && !document.LName ? "User" : `${document.FName} ${document.LName}`}
                  </td>
                  <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>
                    {document.access === 1 ?
                      <i className={"cil-eye"}
                         title={"Visible"}
                         aria-label={"Visible"}
                         style={{cursor: "pointer"}}
                         onClick={() => this.setVisibility(document, 0)}
                      />
                      :
                      <i className={"cil-eye-slash"}
                         title={"Not Visible"}
                         aria-label={"Not Visible"}
                         style={{cursor: "pointer"}}
                         onClick={() => this.setVisibility(document, 1)}
                      />
                    }
                  </td>
                  <td style={{whiteSpace: "pre-wrap", verticalAlign: "top"}}>
                    <i className={"cil-trash"}
                       title={"Delete"}
                       aria-label={"Delete"}
                       style={{cursor: "pointer"}}
                       onClick={() => {
                         const self = this;
                         EventClient.emit("CONFIRM_DIALOG", {
                           message: "Are you sure you want to delete this file?",
                           onOk: () => {
                             self.deleteFile(document);
                           },
                           onCancel: () => undefined
                         })
                       }}
                    />
                  </td>
                </tr>
              })}
              </tbody>
            </table>
          </div>
          {this.state.filesLoading && (
            <div style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              paddingTop: 100,
              backgroundColor: "#fff",
              opacity: 0.5,
              top: 0,
              left: 0
            }}>
              <div className="sk-double-bounce" style={{opacity: 1}}>
                <div className="sk-child sk-double-bounce1"></div>
                <div className="sk-child sk-double-bounce2"></div>
              </div>
            </div>
          )}
        </div>
      )}
    </Dropzone>
  }

}



// WEBPACK FOOTER //
// ./src/containers/Leads/views/DocumentsTab.js